exports = module.exports = require("../../../../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".video-time{font-size:11px;line-height:16px}.video-time__current{margin-right:5px}.video-time__duration{margin-left:5px;color:#919191}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/react-html5video/src/components/controls/time/time.css
// module id = 1376
// module chunks = 0